(function () {
  'use strict';

  /* @ngdoc object
   * @name temporaryWorkers.list
   * @description
   *
   */
  angular
    .module('temporaryWorkers.list', [
      'ui.router'
    ]);
}());
